import { BaseBookingModel, FoodBookingModel } from '../models'

export const isFoodBookingModel = (booking: BaseBookingModel): booking is FoodBookingModel => {
  return !!(booking as FoodBookingModel).amount
}
